import Instrument from './Instrument';

export default Instrument;
